import https from "./https";

const cyberbiz = {
  /**
   * 取得 Cyberbiz merchants 列表
   * @param {string} orgId - 組織 ID
   * @returns {Promise} - merchants 列表
   */
  getMerchants(orgId) {
    if (!orgId) {
      return Promise.reject("id not found.");
    }
    return https.get(`/admin/organizations/${orgId}/cyberbiz/merchants`);
  },

  /**
   * 搜尋 Cyberbiz 顧客
   * @param {string} orgId - 組織 ID
   * @param {object} params - 搜尋參數
   * @returns {Promise} - 搜尋結果
   */
  searchCustomer(orgId, params) {
    if (!orgId) {
      return Promise.reject("id not found.");
    }
    const searchParams = new URLSearchParams(params);

    return https.get(`/admin/organizations/${orgId}/cyberbiz?${searchParams}`);
  },

  /**
   * 查詢 Cyberbiz 訂單
   * @param {string} orgId - 組織 ID
   * @param {object} params - 查詢參數
   * @param {string} params.merchant_id - 商家 Hash ID（必填）
   * @param {string} [params.order_numbers] - 訂單編號，多筆以逗號分隔
   * @param {string} [params.order_id] - 訂單 ID（僅支援單筆）
   * @returns {Promise} - 訂單查詢結果
   */
  searchOrder(orgId, params) {
    if (!orgId) {
      return Promise.reject("orgId not found.");
    }
    if (!params.merchant_id) {
      return Promise.reject("merchant_id is required.");
    }
    if (!params.order_numbers && !params.order_id) {
      return Promise.reject("order_numbers or order_id is required.");
    }

    const searchParams = new URLSearchParams();
    searchParams.append("merchant_id", params.merchant_id);

    if (params.order_numbers) {
      searchParams.append("order_numbers", params.order_numbers);
    } else if (params.order_id) {
      searchParams.append("order_id", params.order_id);
    }

    return https.get(`/admin/organizations/${orgId}/cyberbiz/order?${searchParams}`);
  },
};

export default cyberbiz;
